import React, { useState, FC } from 'react';
import styled from 'styled-components';
import { IoEye, IoEyeOff } from 'react-icons/io5';

interface PasswordInputProps {
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PasswordInputComponent: FC<PasswordInputProps> = ({
  placeholder,
  value,
  onChange,
}) => {
  const [showPassword, setShowPassword] = useState(false); // 비밀번호 표시 여부

  return (
    <PasswordInputContainer>
      <StyledInput
        type={showPassword ? 'text' : 'password'}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      <EyeIcon onClick={() => setShowPassword(!showPassword)}>
        {showPassword ? <IoEye /> : <IoEyeOff />}
      </EyeIcon>
    </PasswordInputContainer>
  );
};

// 스타일 정의
const PasswordInputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 12px;
  padding-right: 40px; /* 아이콘 공간 확보 */
  border: 1px solid ${({ theme }) => theme.colors.inputLine};
  background-color: ${({ theme }) => theme.colors.inputBG};
  border-radius: 6px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.mainColor};
  }
`;

const EyeIcon = styled.div`
  position: absolute;
  right: 10px;
  cursor: pointer;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.subColor};
`;

export default PasswordInputComponent;
